<template>
  <!-- Item -->

    <div class="radio__item">

    <!-- Default input, which is hidden -->

    <input :data-day="day" :disabled="(available == 0 || exceed == 'yes' || allRoomUnavailable == 'yes') && isSmartSpace == false" type="radio" :id="id + '-package-' + day" name="radios" value="" class="radio__input" @change="setSelectedPackage(id, day, position)" :checked="isPackageSelected(id, day)">

    <!-- Content (this needs to be right after radio input for the styles to work properly-->

    <label :for="id + '-package-' + day" class="radio__content">

        <div class="radio__disabled package-disabled" v-if="(exceed == 'yes' || available == 0 || allRoomUnavailable == 'yes') && isSmartSpace == false">
             <!-- Title -->
            <div class="radio__main">
            <div class="radio__head">
                <h2 class="radio__title">{{ title }}</h2>

                <!-- Meta information -->

                <ul class="inline-list inline-list--small radio__meta">
                    <li class="inline-list__item" v-if="!isOpera && !isNew">{{ pType }}</li>
                    <li class="inline-list__item">{{min}}-{{max}} {{ strings.people }}</li>
                </ul>

                <ul class="checklist"> 
                    <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="exceed == 'yes'">{{ strings.yourattendees }} ({{ this.$store.state.delegates }}) {{ strings.exceedthelimit }} {{ strings.thispackage }} ({{max}}) </li>
                    <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="available == 0 && exceed == 'no'">{{ strings.noneofroomavailableinpackage }}</li>
                    <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="allRoomUnavailable == 'yes' && exceed == 'no' && available != 0">{{ strings.noneofroomfitsattendees }}</li>
                </ul>
            </div>
             <div v-if="isSmartSpace == false" class="radio__pricing">
                <h3 class="radio__price" v-if="calculatedPrices.price_vat != 0"> {{ currencySymbol }} {{ $store.state.selectedLang === 'de' ? parseFloat(calculatedPrices.price_vat / 100).toFixed(2).replace('.', ',') : parseFloat(calculatedPrices.price_vat / 100).toFixed(2) }} </h3>
                <h3 class="radio__price" v-else>{{ strings.enquiry }}</h3>
                <h4 class="radio__audience" v-if="calculatedPrices.price_vat != 0">{{ strings.perPerson }}</h4>
                <p class="ribbon" v-if="calculatedPrices.type == 'seasonal_price' && calculatedPrices.price_vat != 0">{{ strings.specialprice }}</p>
                <p class="ribbon" v-if="calculatedPrices.type == 'disc_price'  && calculatedPrices.price_vat != 0">{{ strings.discountprice }}</p>
                <p class="ribbon" v-if="calculatedPrices.type == 'base_price' && isHanselWL && calculatedPrices.price_vat != 0">{{ strings.nondiscountprice }}</p>
                </div>
             <div v-if="isSmartSpace == true" class="radio__pricing">
                <h3 class="radio__price" > {{ currencySymbol }} {{ $store.state.selectedLang === 'de' ? parseFloat(calculatedPrices.price_vat).toFixed(2).replace('.', ',') : parseFloat(calculatedPrices.price_vat).toFixed(2) }} </h3>
               </div>                
            </div>
        </div>
        <div class="radio__main">

        <div class="radio__head">

            <!-- Title -->

            <h2 class="radio__title">{{ title }}</h2>

            <!-- Meta information -->

            <ul class="inline-list inline-list--small radio__meta">
            <li class="inline-list__item" v-if="!isOpera && !isNew">{{ pType }}</li>
            <li class="inline-list__item">{{min}}-{{max}} {{ strings.people }}</li>
            </ul>

            <!-- Package Includes -->
            <div class="radio__single-detail packageIncludes" v-if="contentInclude">
                <h4>{{ strings.packageincludes }}</h4>
                <ul class="checklist">
                    <li v-for="(item,key) in contentInclude" class="checklist__item" :key="key">
                        {{ item.name }} ( {{ item.start_time }} - {{ item.end_time }} )</li>
                </ul>
            </div>
             <p style="font-size:12px;color:#9d9d9d;" v-html="minPackageCharge"></p>   
            <a href="" class="radio__link js-radio-open-details" @click.prevent="toggleDetails()">{{ isHidden ? strings.showdetails : strings.hidedetails }}</a>

        </div>

        <!-- Pricing -->

        <div class="radio__pricing" v-if="isSmartSpace == false">
            <h3 class="radio__price original_price" v-if="hasReducedPrice"> {{ currencySymbol }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck(parseFloat(packagePriceOriginal / 100).toFixed(2).replace('.', ',')) : enquiryPriceCheck(parseFloat(packagePriceOriginal / 100).toFixed(2)) }} </h3>
            <h3 class="radio__price savings" v-if="hasReducedPrice" >{{enquiryPriceCheck(displayDiscountAmount)}}</h3>
            <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}" v-if="calculatedPrices.price_vat != 0"> {{ currencySymbol }} {{ $store.state.selectedLang === 'de' ? enquiryPriceCheck(parseFloat(calculatedPrices.price_vat / 100).toFixed(2).replace('.', ',')) : enquiryPriceCheck(parseFloat(calculatedPrices.price_vat / 100).toFixed(2)) }} </h3>
            <h3 class="radio__price" v-else>{{ strings.enquiry }}</h3>
            <h4 class="radio__audience" v-if="calculatedPrices.price_vat != 0">{{ strings.perPerson }}</h4>
            <p class="aside__total_be" v-if="calculatedPrices.price_vat != 0 && isBE">{{strings.total}} <span class="aside__detail">{{strings.inclVAT}}</span> {{ currencySymbol }} {{ parseFloat(totalPrice / 100).toFixed(2) }} </p>
        </div>

        <div class="radio__pricing" v-if="isSmartSpace == true">
            <!--<p class="ribbon" v-if="demand == 'H'">High demand day</p>
            <p class="ribbon" v-if="demand == 'L'">Low demand day</p>-->
            <!-- <h3 class="radio__price" >{{ parseFloat(calculatedPrices.price_vat ).toFixed(2) }} {{ currencySymbol }}</h3>-->
            <!-- <h4 class="radio__audience" v-if="calculatedPrices.price_vat != 0">{{ strings.perPerson }}</h4>-->
         </div>
        </div>

        <!-- Details -->

        <div class="radio__details js-radio-details" :class="{ 'radio__details--hidden' : isHidden}">

        <!-- Description -->

        <p class="small radio__single-detail packageDescription" v-html="getPackageDescription"></p>
        <!-- Checklists -->

        <div class="radio__single-detail" v-if="!isNew">
            <h4>{{ strings.packageincludes }}</h4>
            <ul class="checklist">
                <li v-for="(item,key) in allIncludes" class="checklist__item" :class="{'checklist__item--not-available': !packageIncludes.includes(item) }" :key="key">{{ item }}</li>
            </ul>
        </div>

        <div class="radio__single-detail">
            <h4>{{ strings.availableintheserooms }}</h4>
            <ul class="checklist">
                <li v-for="(item,key) in rooms" :key="key" class="checklist__item">{{ item.title }}</li>
            </ul>
        </div>

        </div>

        <!-- Call-to-action -->

        <div class="button radio__cta radio__cta--selected" v-if="isPackageSelected(id)">{{ strings.selected }}</div>
        <div class="button radio__cta" v-else>{{ strings.select }}</div>

    </label>

    </div>
</template>

<script>
export default {
    data() {
        return {
            isHidden : true,
            packageType: this.type,
            packageDescription: this.description
        }
    },
    props: [
        'id',
        'title',
        'type',
        'min',
        'max',
        'description',
        'packageIncludes',
        'allIncludes',
        'correctPrice',
        'calculatedPrices',
        'rooms',
        'exceed',
        'available',
        'allRoomExceed',
        'isSmartSpace',
        'allRoomUnavailable',
        'selected_package',
        'day',
        'delegates',
        'isSmartSpace',
        'demand',
        'position',
        'contentInclude',
        'isNew',
    ],
    methods: {
        enquiryPriceCheck(price) {
            if (price === '0.00')
            {
                this.isEnquiry = true;
                return this.$store.state.strings.enquiry;
            }
            return price
        },
        isPackageSelected(packageID, day){
            if(this.isMoreThanOneDay){
                if(this.selected_package == packageID && this.day == day){
                    this.$store.commit('detailsTextPackage', this.isHidden);
                    return true;
                }
            } else {
                if(this.$store.state.selectedPackage == packageID){
                  this.$store.commit('detailsTextPackage', this.isHidden);
                  return true;
                }
            }
        },
        setSelectedPackage(packageID, day, position){
            let self = this;
            this.$store.commit('setSelectedPosition', position);
            if(this.isMoreThanOneDay){
                this.$store.commit('setSelectedPackageForDay', {
                    'packageID' : packageID,
                    'day' : day
                });
            } else {
                this.$store.commit('setSelectedPackage', packageID);
                //this.$store.commit('setRoomsInPackage', packageID)
                this.$store.state.packageInfo.forEach(element => {
                    if(element.id == packageID) {
                        this.$store.dispatch('sortRoomListinPackage', element.rooms);
                        if(self.isOpera){
                            this.$store.commit('setSelectedLayoutinPackage', element.selected_layout);
                        }
                    }
                });
                this.$store.commit('changeSelectedPricePackage', packageID);
            }
        },
        toggleDetails(){
            this.$store.commit('togglePackageDetailId', '');
            this.isHidden = !this.isHidden
        }
    },
    computed: {
        packagePriceOriginal(){
            if(this.correctPrice && this.correctPrice.original_price){
                return this.correctPrice.original_price;
            }else{
                return 0;
            }
        },
        displayDiscountAmount(){
            if (this.correctPrice?.original_price < this.correctPrice?.price) {
                return null
            }
            return Math.round((this.correctPrice?.original_price - this.correctPrice?.price) / this.correctPrice?.original_price * 100) + "% " + this.strings.savings 
        },
        hasReducedPrice(){
            if(window.location.hostname === 'interikea.cwteasymeetings.com'){
                return false;
            }
            return this.correctPrice?.original_price > this.correctPrice?.price && this.correctPrice.show_strike_through
        },
        operaEventList() {
            return this.$store.state.eventList;
        },
        getPackageDescription(){
            let self = this;
            let html_description = "";
            let current = this.$store.state.packageInfo.filter( (el) =>{
                return self.id == el.id;
            });
            if(current[0]){
                html_description = current[0].description; 
            }
            return html_description; 
        },
        _delegates(){
            if(this.isMoreThanOneDay){
                return '';
            } else {
                return `( ${this.$store.state.delegates} )` ;
            }
        },
        totalPrice(){
            let packageMin;
            if(this.isMoreThanOneDay){
                // Get the event list.
                let operaEventList = this.operaEventList;
                operaEventList.forEach(event => {
                    if(parseInt(event.day) == parseInt(this.day)){
                        packageMin = parseInt(event.delegates) > parseInt(this.min) ? parseInt(event.delegates) : parseInt(this.min);
                    }
                });
            } else {
                if(parseInt(this.$store.state.delegates) > parseInt(this.min)){
                    packageMin = this.$store.state.delegates;
                }   else{
                     packageMin = this.min;
                }
            }
            return this.calculatedPrices.price_vat * packageMin;
        },
        isMoreThanOneDay() {
            return this.$store.state.isMoreThanOneDay;
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
        isHanselWL() {
            return this.$store.state.isHanselWL;
        },
        currencySymbol(){
            return this.$store.state.currencySymbol;
        },
        strings(){
            return this.$store.state.strings;
        },
        minPackageCharge(){
            return (this.min && this.min > 1 && parseInt(this.$store.state.delegates) < parseInt(this.min)) ? "*" + this.$store.state.strings.minimumcharge + " <strong>" + this.min + " " +  this.$store.state.strings.people +"</strong>, " + this.$store.state.strings.butyoucan: '';
        },
        pType(){
            let pType = this.packageType;
            let strings = this.$store.state.strings;
            switch (this.packageType) {
                case '4':
                    pType = strings.halfdaypackage;
                    break;
                case '8':
                    pType = strings.fulldaypackage;
                    break;
                case '24':
                    pType = strings.overnightpackage;
                    break;
                case '36':
                    pType = strings.twodayspackage;
                    break;

            }
            return pType;
        },
        roomInfo() {
            this.$store.state.packageInfo.forEach(element => {
                if(element.id == packageID) {
                    return element.rooms;
                }
            });
        },
        activeTranslate() {
            return this.$store.state.isTranslated;
        },
        selectedLang () {
            return this.$store.state.selectedLang;
        },
        toggleDetail() {
          return this.$store.state.togglePackageDetailId;
        },
        isBE() {
            return this.$store.state.isBE;
        },
        currentTab() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.description, lang: this.$store.state.selectedLang }).then((data)=>{
                this.packageDescription = data;
                });
            } else {
                this.packageDescription = this.description;
            }
            return this.$store.state.currentTab;
        }
    },
    watch: {
        toggleDetail() {
          if(this.id == this.$store.state.togglePackageDetailId) {
              this.isHidden = !this.isHidden;
              this.$store.commit('togglePackageDetailId', '');
          }
        },
        activeTranslate() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.description, lang: this.$store.state.selectedLang }).then((data)=>{
                this.packageDescription = data;
                });
            } else {
                this.packageDescription = this.description;
            }
        },
        selectedLang() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.description, lang: this.$store.state.selectedLang }).then((data)=>{
                this.packageDescription = data;
                });
            } else {
                this.packageDescription = this.description;
            }
        },
        available: function(newValue) {
            if(newValue == 0){
                this.isHidden = true;
            }
        },
        exceed: function(newValue){
            if(newValue == 'yes'){
                this.isHidden = true;
            }
        },
        allRoomUnavailable: function(newValue){
            if(newValue == 'yes'){
                this.isHidden = true;
            }
        }
    }
}
</script>

<style scoped>
    .radio input[type=radio]:disabled+.radio__content {
        height: auto;
        min-height: 190px;
    }
    .package-disabled {
        padding-right:20px;
        padding-left:20px;
    }
    .package-disabled .radio__pricing{
        opacity: 0.4;
    }
    .aside__detail {
        font-weight: 400;
        font-size: 12px;
        color: #9d9d9d;
    }
    .aside__total_be {
        flex: 1;
        font-weight: 700;
        font-size: 12px;
    }

    .packageIncludes .checklist__item {
        float: initial !important;
        width : 100% !important;
    }
</style>
